import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", {
  style: {
    "display": "flex",
    "justify-content": "center"
  }
}, [/*#__PURE__*/_createElementVNode("img", {
  src: "img/qrcode.jpg",
  style: {
    "width": "60vw",
    "max-width": "60vh"
  }
})], -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_view = _resolveComponent("router-view");
  const _component_van_config_provider = _resolveComponent("van-config-provider");
  const _component_van_tabbar_item = _resolveComponent("van-tabbar-item");
  const _component_van_tabbar = _resolveComponent("van-tabbar");
  const _component_van_loading = _resolveComponent("van-loading");
  const _component_van_overlay = _resolveComponent("van-overlay");
  const _component_van_dialog = _resolveComponent("van-dialog");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_van_config_provider, null, {
    default: _withCtx(() => [(_openBlock(), _createBlock(_component_router_view, {
      key: _ctx.$route.meta.key
    }))]),
    _: 1
  }), _withDirectives(_createVNode(_component_van_tabbar, {
    modelValue: $data.active,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.active = $event),
    route: ""
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.menus, (item, index) => {
      return _openBlock(), _createBlock(_component_van_tabbar_item, {
        key: index,
        to: item.to,
        icon: item.icon
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(item.text), 1)]),
        _: 2
      }, 1032, ["to", "icon"]);
    }), 128))]),
    _: 1
  }, 8, ["modelValue"]), [[_vShow, $data.show]]), _createVNode(_component_van_overlay, {
    show: $data.showLoading
  }, {
    default: _withCtx(() => [_createVNode(_component_van_loading, {
      type: "spinner",
      style: {
        "display": "flex",
        "height": "100vh",
        "align-items": "center",
        "justify-content": "center"
      },
      vertical: ""
    }, {
      default: _withCtx(() => [_createTextVNode("加载中... ")]),
      _: 1
    })]),
    _: 1
  }, 8, ["show"]), _createVNode(_component_van_dialog, {
    show: $data.showDialog,
    "onUpdate:show": _cache[1] || (_cache[1] = $event => $data.showDialog = $event),
    title: $data.showDialogStr,
    style: {
      "width": "70vw",
      "max-width": "70vh"
    }
  }, {
    default: _withCtx(() => [_hoisted_1]),
    _: 1
  }, 8, ["show", "title"])], 64);
}